import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import stopAllIcon from './icon--stop-all.svg';
import styles from './stop-all.css';

const StopAllComponent = function (props) {
    const {
        active = false,
        className,
        onClick,
        title = 'Stop',
        ...componentProps
    } = props;
    return (
        <button
            className={styles.stopAllButton}
            onClick={onClick}
            {...componentProps}
        >
            <img
                className={classNames(
                    className,
                    styles.stopAll,
                    {
                        [styles.isActive]: active
                    }
                )}
                draggable={false}
                src={stopAllIcon}
                title={title}
            />
        </button>
    );
};

StopAllComponent.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string
};

export default StopAllComponent;
